<template>
  <v-data-table
    :headers="headers"
    :items-length="items.length"
    :items="items"
    :footer-props="footerProps"
    :disable-sort="false"
    :show-select="showSelect"
    :item-key="itemKey"
    :items-per-page.sync="itemsPerPage"
    :search="search"
    :custom-filter="filterBySearch"
    :page.sync="page"
    @current-items="updateCurrentItems"
  >
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :slot="slot" :name="slot" />
    <!-- Pass on all scoped slots -->
    <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
      <slot :name="slot" v-bind="scope" :props="{ page, itemsPerPage, currentItems }" />
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'RaffleTable',
  props: {
    items: {
      type: Array,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    search: {
      type: String,
      required: false,
    },
    footerProps: {
      type: Object,
      default: () => ({ itemsPerPageOptions: [5, 10, 15] }),
    },
    customItemsPerPage: {
      type: Number,
      default: 10,
    },
    disableSort: {
      type: Boolean,
      default: false,
    },
    transformFunction: {
      type: Function,
      default: (item) => item,
    },
    filterItemsBySearch: {
      type: Function,
      default: (items) => items,
    },
    showSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    itemKey: {
      type: String,
      required: false,
      default: '',
    },
  },
  data: () => ({
    page: 1,
    itemsPerPage: 10,
    currentItems: [],
  }),
  methods: {
    filterBySearch(value, search, item) {
      this.page = 1
      return this.filterItemsBySearch(item, search)
    },
    updateCurrentItems(items) {
      this.currentItems = items
    },
  },
}
</script>

<style></style>
